import { segmentSchema } from ".";
import yup from "../../../utils/yup";

export const segmentFormSchema = yup.object({
  segment: segmentSchema
    .shape({ name: yup.string().required("Enter the Segment's name") })
    .nullable()
    .default(null),
});
